import { useNavigate } from 'react-router-dom'

import Button from 'src/ui/atoms/Button'

export interface ICardAlternate {
  id: string
  title: string
  icon: string
  status: string
  data: { type: string; value: string }[]
  network: string
  chain: string
  createdAt: string
}

const Card = ({ id, title, icon, data, network, chain, createdAt }: ICardAlternate) => {
  const navigate = useNavigate()

  return (
    <div className="grid gap-6 rounded-lg bg-navy-blue p-6 text-white">
      <span className="flex items-center justify-between">
        <span
          className={`icon-${icon} h-12 w-12 rounded-lg bg-white bg-opacity-20 text-center text-xl leading-[48px] text-main-blue`}></span>
        <span className="text-sm font-normal">{createdAt}</span>
      </span>
      <span className="grid gap-1">
        <h2 className="mt-6 md:mt-10">{title}</h2>
        {data.map(({ type, value }, key) => (
          <p key={key} className="font-normal">
            {type}: {value}
          </p>
        ))}
      </span>
      <span className="flex items-end justify-between">
        <span className="grid grid-flow-col items-center gap-2">
          <span className={`icon-${chain} text-xl text-white`} />
          {network}
        </span>
        <span className="grid grid-flow-row gap-1">
          <Button name="View" size="M" onClick={() => navigate(`/projects/${id}`)} />
        </span>
      </span>
    </div>
  )
}

export default Card
